import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Pickr from '@simonwep/pickr/dist/pickr.min';
import {ColorTheme} from "../../models/color-theme";

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent implements OnInit {

  @Input() color: string;
  @Output() colorChange = new EventEmitter<string>();

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.createColorPicker();
  }

  private createColorPicker() {
    const defaultTheme = new ColorTheme();
    const pickr = Pickr.create({
      el: '.picker',
      theme: 'monolith',
      default: this.color || '#5e8d93',
      swatches: [
        defaultTheme.colorPrimary,
        defaultTheme.colorSecondary,
        defaultTheme.colorTertiary,
        defaultTheme.colorSuccess,
        defaultTheme.colorWarning,
        defaultTheme.colorDanger
      ],
      position: 'bottom-end',
      components: {
          preview: true,
          hue: true,
          interaction: { input: true, save: true }
      },
      i18n: {
        'btn:save': this.translateService.currentLang === 'pt' ? 'Guardar' : 'Save',
        'btn:cancel': this.translateService.currentLang === 'pt' ? 'Cancelar' : 'Cancel',
      }
    });

    pickr.on('save', (color) => {
      this.color = color.toHEXA().toString();
      this.colorChange.emit(this.color);

      pickr.hide();
    });

    return pickr;
  }

}
